import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1aa704ba&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=1aa704ba&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa704ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa704ba')) {
      api.createRecord('1aa704ba', component.options)
    } else {
      api.reload('1aa704ba', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=1aa704ba&scoped=true", function () {
      api.rerender('1aa704ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ellipsis-tooltip/Index.vue"
export default component.exports